/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1TutoraiConfigPersonaQueryResponse,
  GetApiV1TutoraiConfigPersonaQueryParams,
  GetApiV1TutoraiConfigPersona401,
  GetApiV1TutoraiConfigPersona500,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigPersona.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1TutoraiConfigPersona } from "../../clients/tutorAIConfigController/getApiV1TutoraiConfigPersona.ts";

export const getApiV1TutoraiConfigPersonaQueryKey = (
  params?: GetApiV1TutoraiConfigPersonaQueryParams,
) =>
  [
    { url: "/api/v1/tutorai/config/persona" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1TutoraiConfigPersonaQueryKey = ReturnType<
  typeof getApiV1TutoraiConfigPersonaQueryKey
>;

export function getApiV1TutoraiConfigPersonaQueryOptions(
  params?: GetApiV1TutoraiConfigPersonaQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1TutoraiConfigPersonaQueryKey(params);
  return queryOptions<
    GetApiV1TutoraiConfigPersonaQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigPersona401 | GetApiV1TutoraiConfigPersona500
    >,
    GetApiV1TutoraiConfigPersonaQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1TutoraiConfigPersona(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna o system prompt configurado. Se `classStudentId` for informado, retorna a persona específica da turma com fallback para a global. `content` é `null` quando não configurada. **(Requer Authorization para autenticação)**
 * @summary Obter persona do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/persona}
 */
export function useGetApiV1TutoraiConfigPersona<
  TData = GetApiV1TutoraiConfigPersonaQueryResponse,
  TQueryData = GetApiV1TutoraiConfigPersonaQueryResponse,
  TQueryKey extends QueryKey = GetApiV1TutoraiConfigPersonaQueryKey,
>(
  params?: GetApiV1TutoraiConfigPersonaQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1TutoraiConfigPersonaQueryResponse,
        ResponseErrorConfig<
          GetApiV1TutoraiConfigPersona401 | GetApiV1TutoraiConfigPersona500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1TutoraiConfigPersonaQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1TutoraiConfigPersonaQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigPersona401 | GetApiV1TutoraiConfigPersona500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
